<template>
  <div class="container-fluid pt-4">
    <div class="row">
      <!-- left -->
      <div class="bd-sidebar col-md-3 col-xl-2 col-12"></div>
      <!-- center -->
      <div class="bd-content col-md-9 col-xl-8 col-12 pb-md-3 text-center">
        <div v-if="$store.state.login.token">
          <h1>Pacientes</h1>
          <patients-table 
            :patients="patients"
            :is-loading="isLoading"
            :total-patients="totalPatients" 
            :per-page="patientsPerPage" 
            :current-page="currentPage"
            @load-page="getPatients"
          />
          <b-button variant="info" class="m-2" @click="showModal">Nuevo paciente</b-button>
        </div>
        <div v-else>
          <h1>Inicia sesión</h1>
          Debes iniciar sesión para poder usar la plataforma.
        </div>
      </div>
      <!-- right -->
      <div class="bd-toc col-xl-2 d-none d-xl-block">
        <div class="side-sticky">
          <ul class="section-nav nav flex-column"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PatientsTable from "../components/table/PatientsTable";
import patientService from "../services/patientService";

export default {
  name: "Home",
  components: { PatientsTable },
  computed: mapState(["login"]),
  data: function() {
    return {
      polls: [],
      patients: [],
      isLoading: true,
      patientsPerPage: 10,
      totalPatients: 10,
      currentPage: 1
    };
  },
  mounted: function() {
    if (this.$store.state.login.token) {
      this.getPatients();
    }
  },
  methods: {
    getPatients: function(page=1, search="") {
      this.isLoading = true;
      this.patients = []
      patientService.get_patients({
        page: page,
        patients_per_page: this.patientsPerPage,
        search: search
      }).then(
        data => {
          this.patients = data.patients;
          this.totalPatients = data.total_patients;
          this.currentPage = page;
          this.isLoading = false;
        },
        error => {
          console.error(error);
        }
      );
    },
    showModal: function() {
      const params = {
        title: "Crear paciente",
        patientData: {
          first_name: "",
          last_name: "",
          rut: "",
          email: ""
        },
        // we are passing callback method for our confirm button
        onConfirm: patientData => {
          if (
            patientData.first_name.length > 0 &&
            patientData.last_name.length > 0
          ) {
            this.createPatient(patientData);
            return true;
          } else {
            this.$toasted.error(
              "Debes agregar el nombre y apellido del paciente!"
            );
            return false;
          }
        },
        confirmText: "Crear"
      };
      this.$patientModal.show(params);
    },
    createPatient: function(patientData) {
      this.isLoading = true;
      patientService.create_patient(patientData).then(
        data => {
          this.isLoading = false;
          this.$toasted.success(data.message);
          this.getPatients();
        },
        // eslint-disable-next-line
        error => {
          this.isLoading = false;
          this.$toasted.error(error.message);
        }
      );
    }
  },
  watch: {
    // eslint-disable-next-line
    "login.token": function(newValue, oldValue) {
      if (newValue) {
        this.getPatients();
      } else {
        this.patients = [];
      }
    }
  }
};
</script>

<style>
.bd-sidebar {
  border-right: 1px solid #eee;
}
.bd-toc {
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
</style>